import Http from "./http";

export const getProductFeatureContentAPI = (data) => {
  return Http.post("admin/product/getProductFeatureContent",data);
};
